// v642.1: Character Hub tab bar.
//
// Floating tab strip rendered above whichever character-side panel is
// currently open (Inventory / Equipment / Skills / Deck). Lets the player
// switch among them with one click without closing/reopening modals,
// reducing modal-juggling friction.
//
// Implementation note: each underlying panel still renders its own modal
// shell; this strip floats above with a higher z-index. The "active" tab
// is the one whose panel is currently mounted.

import React from 'react';

const TABS = [
  // v642.15: this tab opens CharacterSheet — relabel from "Equipment"
  // to match what the user actually sees when they click it.
  { key: 'equipment', label: 'Character', icon: '⚔️' },
  { key: 'inventory', label: 'Inventory', icon: '🎒' },
  { key: 'skills',    label: 'Skills',    icon: '🌳' },
  { key: 'deck',      label: 'Deck',      icon: '🃏' },
];

const CharacterHubTabBar = ({ activeTab, onSwitch }) => {
  if (!activeTab) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 10,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 10001, // above modal-overlays (typically 9999/10000)
        display: 'flex',
        gap: 4,
        padding: 4,
        background: 'rgba(18, 24, 36, 0.92)',
        border: '1px solid rgba(212, 175, 55, 0.45)',
        borderRadius: 22,
        boxShadow: '0 4px 14px rgba(0, 0, 0, 0.55)',
        pointerEvents: 'auto',
      }}
      role="tablist"
      aria-label="Character hub"
    >
      {TABS.map(t => {
        const active = t.key === activeTab;
        return (
          <button
            key={t.key}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={(e) => { e.stopPropagation(); if (!active) onSwitch(t.key); }}
            title={t.label}
            style={{
              padding: '5px 12px',
              border: '1px solid ' + (active ? '#d4af37' : 'transparent'),
              background: active
                ? 'linear-gradient(180deg, rgba(212, 175, 55, 0.28), rgba(212, 175, 55, 0.10))'
                : 'transparent',
              color: active ? '#ffe48a' : '#cfd6e4',
              borderRadius: 18,
              cursor: active ? 'default' : 'pointer',
              fontSize: 12,
              fontWeight: 600,
              display: 'flex',
              alignItems: 'center',
              gap: 5,
              minWidth: 78,
              justifyContent: 'center',
              transition: 'background 0.15s',
            }}
          >
            <span style={{ fontSize: 13 }}>{t.icon}</span>
            <span>{t.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default CharacterHubTabBar;
